import { render, staticRenderFns } from "./kpi-rank-person.vue?vue&type=template&id=966ec52c&scoped=true"
import script from "./kpi-rank-person.vue?vue&type=script&lang=js"
export * from "./kpi-rank-person.vue?vue&type=script&lang=js"
import style0 from "./kpi-rank-person.vue?vue&type=style&index=0&id=966ec52c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966ec52c",
  null
  
)

export default component.exports